export default __webpack_public_path__ + "static/media/iconPaymentVirement.2e418c0e.svg";